import React, { Component } from 'react';
import 'rc-notification/assets/index.css';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import 'rc-color-picker/assets/index.css';
import Notifications from './components/notifications/Notifications';
// eslint-disable-next-line
import UserLogin from './components/UserLogin';
import Router from './components/Routes';

class App extends Component {
    render() {
        return (
            <div className="App" >
                <Router />
                {/* <UserLogin /> */}
                <Notifications />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js